import { render } from "./marketingPage.vue?vue&type=template&id=763327c7"
import script from "./marketingPage.vue?vue&type=script&lang=js"
export * from "./marketingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__